var headerContext = {
    componentName: '@layout/Header'
};

export { headerContext };
